import React from 'react';
import FadeInAnimationWrapper from 'src/elements/animation/fade-in/FadeInAnimationWrapper';
import Paragraph from 'src/elements/typography/paragraph';
import Exclaim from 'src/images/Exclaim';
import { EmptyResultMessageContainer } from './EmptyResultMessage.styles';

const EmptyResultMessage = (): JSX.Element => {
  return (
    <FadeInAnimationWrapper>
      <EmptyResultMessageContainer>
        <Exclaim />
        <Paragraph
          text="Sorry, we're not sure what you meant by that. Could you try rephrasing or using a different term?"
          standardSize='1'
          align='left'
          weight={500}
        />
      </EmptyResultMessageContainer>
    </FadeInAnimationWrapper>
  );
};

export default EmptyResultMessage;
